import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionStorageService } from '../../../core/services/web-storage';
import { CacheService } from '../../../core/services/cache';
import { RegiaoLocalizacoesResponse } from '../adapters';

@Injectable({
  providedIn: 'root'
})
export class RegiaoLocalizacoesCacheService implements OnDestroy {
    /** Variável em memória do cache local */
    private localizacoes: RegiaoLocalizacoesResponse;
    /** Storage Key para o Session Storage */
    private readonly STORAGE_KEY = 'regioes-localizacoes';
    /** Assinaturas de eventos */
    private subscriptions = new Subscription();

    constructor(private sessionStorageService: SessionStorageService,
                private cacheService: CacheService) {
        // Obtem do Session Storage caso já estiver armazenado localmente
        this.localizacoes = null; // this.getFromStorage();

        // Assinaturas
        this.subscriptions.add(
            // Assina o evento de limpeza do cache
            this.cacheService.clearAllCache$.subscribe(() => this.clear())
        );
    }

    /** Retorna as localizações armazenadas no cache */
    getLocalizacoes(): RegiaoLocalizacoesResponse | null {
        return this.localizacoes;
    }

    /** Seta e atualiza as localizações no cache */
    setLocalizacoes(localizacoes: RegiaoLocalizacoesResponse) {
        this.localizacoes = localizacoes;
        // this.setToStorage(localizacoes);
    }

    /** Tenta obter as localizações armazenadas no Session Storage */
    /*private getFromStorage(): RegiaoLocalizacoesResponse | null {
        const objStorage = this.sessionStorageService.get(this.STORAGE_KEY);
        if (objStorage) { // Se encontrar cria o objeto e retorna as localizações
            return RegiaoLocalizacoesResponse.fromJSON(objStorage);
        }
        // Se não retorna null para informar que não possui nada armazenado localmente
        return null;
    }*/

    /** Seta as localizações no Session Storage */
    /*private setToStorage(localizacoes: RegiaoLocalizacoesResponse) {
        this.sessionStorageService.setObject(this.STORAGE_KEY, localizacoes);
    }*/

    /** Limpa o cache */
    clear() {
        // Removendo do Session Storage
        this.sessionStorageService.remove(this.STORAGE_KEY);
        // Limpando variável em memória
        this.localizacoes = null;
    }

    ngOnDestroy() {
        // Fazendo unsubscribe do evento de limpeza do Session Storage
        this.subscriptions.unsubscribe();
    }
}
